const headerHeight = () => {
    let height = $("#header").height();
    $("#header-padding").css("padding-top", height);
};

export default headerHeight